<template>
    <div class="main main-padding tabs-data-details">
        <!--数据信息-->
        <card>
            <div class="details-card-header-area">
                <!--tab切换数据-->
                <div class="details-tab-data">
                    <span>学校列表</span>
                </div>
                <!--搜索框-->
                <div class="input-data">
                    <Input
                        v-model="keyWord"
                        placeholder="支持学校名称关键字搜索"
                        icon="ios-search"
                        clearable
                        @on-enter="handleSearch"
                    >
                        <Button
                            slot="append"
                            icon="ios-search"
                            class="search-input-button"
                            @click="handleSearch"
                            type="primary"
                        ></Button>
                    </Input>
                </div>
            </div>
            <div>
                <!--学校列表-->
                <div class="table-wrapper-data">
                    <Table :columns="schoolColumn" :data="schoolList"></Table>
                </div>
                <!--分页,大屏重复绑定情况下不显示-->
                <div class="laypage_main">
                    <Page
                        :total="total"
                        :current="page"
                        :page-size="limit"
                        @on-change="handleCurrentChange"
                        v-show="total && pageCount>1"
                        show-total
                    />
                </div>
            </div>
        </card>
    </div>
</template>

<script>
    import {getConversationSchoolList} from "../../../service/api.js";

    export default {
        name: "conservation-count",
        data () {
            return {
                keyWord: '',//关键字
                schoolList: [],//学校列表
                total: 0,//数据量
                page: 1,//当前页
                limit: 10,//每页数据
                pageCount: 0,//页数
                schoolColumn: [
                    {
                        title: "序号",
                        key: "rowNum",
                        align: "center"
                    },
                    {
                        title: "学校名称",
                        key: "school_name",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "a",
                                    {
                                        attrs: {
                                            title: "点击查看学校详情",
                                            href: "javascript:void(0);"
                                        },
                                        style: {
                                            color: "bule",
                                            fontSize: "12px"
                                        },
                                        on: {
                                            click: () => {
                                                this.lookSchoolDetails(params.row);
                                            }
                                        }
                                    },
                                    params.row.school_name
                                )
                            ]);
                        }
                    },
                    {
                        title: "教师数",
                        key: "studentCount",
                        align: "center"
                    },
                    {
                        title: "学生数",
                        key: "studentCount",
                        align: "center"
                    }
                ],
            }
        },
        methods: {
            /**
             *搜索关键字
             */
            handleSearch () {
                this.total = 0;
                this.page = 1;
                //查看用户列表
                this.queryConversationSchoolList();
            },
            /**
             *翻页
             */
            handleCurrentChange (val) {
                this.page = val;
                //查看用户列表
                this.queryConversationSchoolList();
            },
            /**
             *点击查看学校详情
             */
            lookSchoolDetails(row){
                this.$router.push({
                    name: "userConservationList",
                    query: {
                        schoolId: row.school_id,
                        schoolName: row.school_name
                    }
                });
            },
            /**
             *查看用户列表
             */
            async queryConversationSchoolList () {
                let _this = this;
                let params={
                    keyWord:_this.keyWord,
                    page:_this.page,
                    limit:_this.limit
                };
                await getConversationSchoolList(params)
                    .then(function (data) {
                        if (Object.keys(data).length !== 0) {
                            _this.schoolList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            }
        },
        mounted () {
            // 查看用户列表
            this.queryConversationSchoolList();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../style/home";
    @import "../../../style/dataDetails";
</style>
<style lang="scss">
    .tabs-data-details {
        .ivu-card {
            margin-top: 50px !important;
        }

        .ivu-input-group {
            width: 300px;
            float: right;
            top: 0;
        }

        .ivu-card-body {
            padding: 16px;
        }

        .time-slot .ivu-col-span-lg-4 {
            display: block;
            width: 355px;
        }

        .ivu-row {
            margin-top: 0 !important;
        }

        .ivu-input-group-append .ivu-btn, .ivu-input-group-prepend .ivu-btn {
            color: #fff;
            background: #57a3f3;
        }

        .ivu-input-group .ivu-input {
            font-size: 14px;
        }

        .ivu-btn-icon-only {
            border-radius: 0 4px 4px 0;
        }

        .ivu-input-icon-clear {
            margin-right: 45px;
        }

        .ivu-table {
            font-size: 14px;
        }

        .ivu-table-tip {
            overflow-x: hidden;
        }

        .ivu-tabs-nav {
            font-size: 14px;
        }

        .ivu-table-overflowX {
            overflow-x: hidden;
        }
    }
</style>
